import Currency from '$utils/currency'
import { isAuthenticated } from './user.js'
import { getCurrentLocation } from './location.js'
import * as cookie from '$utils/cookie'

export const getCurrentCurrency = async () => {
  let selectedCurrency = getSelectedCurrency()
  if (selectedCurrency) {
    return selectedCurrency
  }

  if (!isAuthenticated()) {
    selectedCurrency = cookie.get(getCurrencyCookieName())
    if (selectedCurrency) {
      return selectedCurrency
    }
  }

  let currentLocation

  try {
    currentLocation = await getCurrentLocation()
  } catch (error) {
    console.error(error)
  }

  const currentCountryCode =
    currentLocation && currentLocation.country_code ? currentLocation.country_code : window.UFE.defaultCountry

  return window.CURRENCIES.COUNTRIES[currentCountryCode]
}

export const getSelectedCurrency = () => {
  return window.CURRENCIES.SELECTED
}

export const getCurrencyCookieName = () => {
  return window.UFE.cookies.currency
}

export const initCurrencyHelper = (lang, currency) => {
  new Currency(
    {
      lang: lang,
      currency: currency
    },
    {
      regex: /(<span class="amount-trigram">\s?\w+<\/span>)/,
      formatTrigram: function(trigram, separator) {
        return '<span class="amount-trigram">' + separator + trigram + '</span>'
      },
      formatValue: function(val) {
        return '<span class="amount-text">' + val + '</span>'
      },
      currencies: window.CURRENCIES.SYMBOLS,
      rates: window.CURRENCIES.RATES
    }
  )
}
